import * as React from 'react';
import * as cx from 'classnames';
import {
  Paper,
  createStyles,
  withStyles,
  WithStyles,
  Theme,
} from '@material-ui/core';
import { units } from 'ha/theme/utils';

type Kind = 'mint' | 'muted' | 'mint-left-no-radius';

const styles = (t: Theme) =>
  createStyles({
    base: {
      display: 'inline-block',
      fontSize: units.rem(0.85),
      padding: units.trbl(0.25, 0.5, 0.25, 0.5),
    },
    'kind-mint': {
      color: '#fff',
      backgroundColor: t.palette.mint.main,
    },
    'kind-mint-left-no-radius': {
      color: '#fff',
      backgroundColor: t.palette.mint.main,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    'kind-muted': {
      backgroundColor: t.palette.grey[200],
      color: t.palette.secondary.main,
    },
  });

interface Props {
  className?: string;
  kind?: Kind;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const Badge: React.SFC<Props & WithStyles<typeof styles>> = ({
  className = '',
  kind,
  children,
  classes,
  onClick,
  ...rest
}) => (
  <Paper
    elevation={0}
    className={cx(classes.base, {
      [classes[`kind-${kind}`]]: Boolean(kind),
    })}
    onClick={onClick}
    {...rest}
  >
    {children}
  </Paper>
);

export default withStyles(styles)(Badge);
